import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * QR-Code auf Papier (Okt 2026, wie im Werbespot, Motion-Kit `.eo-qr__paper`).
 *
 * Immer weisser Grund mit Ruhezone und feinem Rand (Kameras brauchen hellen
 * Grund, auch im Dunkelmodus — siehe `--color-paper`), darum vier Scan-Ecken
 * in Tinte, die sagen: hier draufhalten.
 *
 * Beim ersten Zeigen eines Codes baut er sich diagonal von oben links auf
 * (`.qr-build`, 0,42 s). Danach steht er — wer zwischen Code und QR hin- und
 * herschaltet, sieht die Animation nicht jedes Mal.
 *
 * - animateKey: der Inhalt des Codes (z.B. Session-Code); ohne ihn kein Aufbau
 * - corners:    Scan-Ecken zeigen (Standard)
 */

// Welche Codes in dieser App-Sitzung schon aufgebaut wurden.
const built = new Set();

const QrPaper = ({ children, animateKey, corners = true, className = '' }) => {
  // Einmal beim Einhaengen entschieden. `built` wird erst nach dem Aufbau
  // gefuellt (onAnimationEnd), damit ein doppeltes Rendern im StrictMode
  // den Aufbau nicht verschluckt.
  const [build] = useState(() => animateKey != null && !built.has(animateKey));

  return (
    <div className={`relative inline-block ${className}`}>
      <div className="rounded-xl border border-border bg-paper p-3.5">
        <div
          className={build ? 'qr-build' : undefined}
          onAnimationEnd={() => { if (animateKey != null) built.add(animateKey); }}
        >
          {children}
        </div>
      </div>
      {corners && (
        <div className="pointer-events-none absolute -inset-1.5" aria-hidden="true">
          <span className="absolute left-0 top-0 h-[26px] w-[26px] rounded-tl-[10px] border-l-[3px] border-t-[3px] border-foreground" />
          <span className="absolute right-0 top-0 h-[26px] w-[26px] rounded-tr-[10px] border-r-[3px] border-t-[3px] border-foreground" />
          <span className="absolute bottom-0 left-0 h-[26px] w-[26px] rounded-bl-[10px] border-b-[3px] border-l-[3px] border-foreground" />
          <span className="absolute bottom-0 right-0 h-[26px] w-[26px] rounded-br-[10px] border-b-[3px] border-r-[3px] border-foreground" />
        </div>
      )}
    </div>
  );
};

QrPaper.propTypes = {
  children: PropTypes.node.isRequired,
  animateKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  corners: PropTypes.bool,
  className: PropTypes.string,
};

export default QrPaper;
